/*
 * Copyright (c) 2023 Roboto Technologies, Inc.
 */
import { Box, useTheme } from "@mui/material";
import * as React from "react";

import { useAuth } from "@/providers";
// TODO split up organization settings and put into shared components
import { OrganizationSettings } from "@/Settings/OrganizationSettings";
import type { OrgRecord } from "@/shared/domain/orgs";

import { AllOrgsViewer } from "./AllOrgsViewer";

export function Orgs() {
  const { currentOrganization, currentUser } = useAuth();
  const theme = useTheme();

  // Local "previewed org" — defaults to the admin's own current org so
  // the right-hand panel isn't empty on first paint. Clicking any row in
  // the table updates this without touching the global auth state, so
  // the admin can browse other orgs' settings without leaving their
  // own. (Use `View As` if you want to actually act as that org.)
  const [selectedOrg, setSelectedOrg] = React.useState<OrgRecord | null>(
    currentOrganization,
  );

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "45% 45%",
        columnGap: theme.spacing(2.5),
        rowGap: theme.spacing(2.5),
        mt: theme.spacing(1),
        overflowX: "auto",
        pb: theme.spacing(0.5),
      }}
    >
      <AllOrgsViewer onSelectOrg={setSelectedOrg} />
      <OrganizationSettings
        currentOrg={selectedOrg}
        currentUser={currentUser}
        onOrgUpdated={setSelectedOrg}
      />
    </Box>
  );
}
